"use client";
import { j as e } from "./jsx-runtime-CJ-St4mQ.mjs";
import { forwardRef as p, useState as f, useImperativeHandle as C } from "react";
import { t as w } from "./tv.config-BuYIgndg.mjs";
import m from "./Typography.js";
import h from "./IconButton.js";
const g = ({
  title: n,
  titleId: o,
  desc: t,
  descId: s,
  ...r
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    className: "size-6",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": o,
    "aria-describedby": s,
    ...r,
    children: [
      t ? /* @__PURE__ */ e.jsx("desc", { id: s, children: t }) : null,
      n ? /* @__PURE__ */ e.jsx("title", { id: o, children: n }) : null,
      /* @__PURE__ */ e.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M5 12h14" })
    ]
  }
), v = ({
  title: n,
  titleId: o,
  desc: t,
  descId: s,
  ...r
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    className: "size-6",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": o,
    "aria-describedby": s,
    ...r,
    children: [
      t ? /* @__PURE__ */ e.jsx("desc", { id: s, children: t }) : null,
      n ? /* @__PURE__ */ e.jsx("title", { id: o, children: n }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M12 4.5v15m7.5-7.5h-15"
        }
      )
    ]
  }
), b = w({
  slots: {
    root: "Counter__root flex place-items-center",
    counterText: ["Counter__text", "min-w-8 text-center px-4"],
    counterButton: [
      "Counter__button",
      "!rounded-full",
      "text-primary-main",
      "shadow-lg"
    ]
  },
  variants: {
    size: {
      small: ["size-6"],
      medium: ["size-8"],
      large: ["size-10"]
    }
  },
  defaultVariants: {
    size: "medium"
  }
}), {
  root: k,
  counterText: y,
  counterButton: x
} = b(), N = p((n, o) => {
  const { name: t, size: s, label: r, className: a, onChange: c, defaultCount: d = 0 } = n, [i, j] = f(d);
  C(o, () => ({
    currentCount: i
  }));
  const u = (l) => {
    i + l >= d && (j(i + l), typeof c == "function" && c(i + l));
  };
  return /* @__PURE__ */ e.jsxs("div", { children: [
    !!r && /* @__PURE__ */ e.jsx(m, { className: "text-gray-500 mb-2", children: r }),
    /* @__PURE__ */ e.jsxs("div", { className: k({}), children: [
      /* @__PURE__ */ e.jsx(
        h,
        {
          className: x({
            size: s,
            class: a
          }),
          onClick: () => u(-1),
          children: /* @__PURE__ */ e.jsx(g, { name: `${t}-count-increment` })
        }
      ),
      /* @__PURE__ */ e.jsx(
        m,
        {
          variant: "h5",
          className: y({
            class: a
          }),
          children: i
        }
      ),
      /* @__PURE__ */ e.jsx(
        h,
        {
          className: x({
            size: s,
            class: a
          }),
          onClick: () => u(1),
          children: /* @__PURE__ */ e.jsx(v, { name: `${t}-count-decrement` })
        }
      )
    ] })
  ] });
});
N.displayName = "Counter";
export {
  N as default
};
